import React, {useEffect, useState} from "react";
import {NavLink, useHistory, useLocation} from 'react-router-dom'
import _routes from "../routers/router";
import icon1 from '../images/icon1.png';
import icon2 from '../images/icon2.png';
import icon3 from '../images/icon3.png';
import icon4 from '../images/icon4.png'

const pathToRegexp = require('path-to-regexp');

interface navItem {
    name: string,
    icon: string,
    path: string
}

const routes_: Array<navItem> = [{
    name: '发现',
    path: '/',
    icon: icon1
}, {
    name: '课程',
    path: '/course',
    icon: icon2
}, {
    name: '求职',
    path: '/job',
    icon: icon3
}, {
    name: '我的',
    path: '/user',
    icon: icon4
}]

function isMainMenu(path:string):boolean {

    const result = routes_.findIndex(item => item.path === path);

    return result !== -1;

}

function Nav() {
    let location = useLocation();
    let history = useHistory();



    const [state,setState] = useState(true);

    useEffect(() => {

        // 路由变化更新页面标题
        for (let i = 0; i < _routes.length; i++) {
            const item = _routes[i];
            const urlReg = pathToRegexp(location.pathname)
            if (urlReg.test(item.path)) {
                document.title = item.title || 'TIBA荷兰国际管家学院';
                break;
            }
        }

        // 当 history 长度为一的时候显示底部菜单导航
        setState(history.length > 1 ? isMainMenu(location.pathname) : true)

        // 复位滚动条
        if(history.action === 'PUSH'){
            window.scrollTo(0,0)
        }

    }, [location,history])
    return <div className={ state ? 'active nav' : 'nav'}>
        {
            routes_.map((item, index) => {
                return <NavLink to={item.path} className='item' key={index} exact>
                    <img src={ item.icon } alt=""/>
                    <p className="title">{item.name}</p>
                </NavLink>
            })
        }
    </div>
}

export default Nav;
